import axios from "axios";

export type TabMenuItem = {
  label: string;
  dataId: string;
  tag: string;
};

export const fetchFunctionalAreas = async (): Promise<any> => {
  const url = process.env.NEXT_PUBLIC_FUNCTIONAL_AREAS_S3_URL || '';
  const response = await axios.get(url);
  return response?.data || {};
};

export const getFunctionalAreaClusterById = async (
  id: string | number
): Promise<string | number | null> => {
  try {
    const data = await fetchFunctionalAreas();
    if (!data || typeof data !== 'object') return null;
    const list = Array.isArray((data as any)?.functionalareas)
      ? (data as any).functionalareas
      : [];
    if (list.length === 0) return null;

    const targetIdNum = Number(id);
    const item = list.find((fa: any) =>
      typeof fa?.id === 'number'
        ? fa.id === targetIdNum
        : String(fa?.id) === String(id)
    );
    return item?.cluster ?? null;
  } catch {
    return null;
  }
};

export type CategoryTab = {
  heading: string;
  label: string;
  dataId: string;
  tag: string;
  icon?: string;
  menu: TabMenuItem[];
};

const setWithExpiry = (key: string, data: any, ttl: number = 24 * 60 * 60 * 1000): void => {
  const now = new Date();
  const item = {
    value: data,
    expiry: now.getTime() + ttl, // expires in 1 day
  };
  window.localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key: string): any | null => {
  const itemStr = window.localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    if (new Date().getTime() > item.expiry) {
      window.localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    return null;
  }
};  

export const toCategoryTag = (name: string) =>
  (name || '')
    .toLowerCase()
    .replace(/\s+jobs$/i, '')
    .replace(/&/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const loadIimjobsCategoriesTabs = async (
  storageKey = 'categories_extended_iimjobs'
): Promise<CategoryTab[]> => {
  try {
    if (process.env.NEXT_PUBLIC_APP_NAME !== 'iimjobs') return [];
    const s3Url = process.env.NEXT_PUBLIC_CATEGORIES_S3_URL as
      | string
      | undefined;
    if (typeof window !== 'undefined') {
      const cached = getWithExpiry(storageKey);
      if (cached) {
        if (Array.isArray(cached) && cached.length > 0) {
          return cached as CategoryTab[];
        }
      }
    }

    if (!s3Url) return [];
    const res = await fetch(s3Url);
    if (!res.ok) return [];
    const json = await res.json();
    const source = Array.isArray(json)
      ? json
      : Array.isArray(json?.category)
      ? json.category
      : [];

    const transformed: CategoryTab[] = source.map((cat: any) => {
      const label = cat?.name || '';
      const dataId = String(cat?.id ?? '');
      const heading = label;
      const tag = toCategoryTag(label);
      const icon = cat?.icon || '';
      const tags = Array.isArray(cat?.tags) ? cat.tags : [];
      const menu: TabMenuItem[] = tags.map((t: any) => ({
        label: t?.name || '',
        dataId: String(t?.id ?? ''),
        tag: toCategoryTag(t?.name || ''),
      }));
      return {heading, label, dataId, tag, menu, icon};
    });

    if (transformed.length > 0 && typeof window !== 'undefined') {
      setWithExpiry(storageKey, transformed);
    }
    return transformed;
  } catch {
    return [];
  }
};
